import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {LocalStorageService} from '../share/localstorage.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DialogComponent} from '../dialog/dialog.component';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-user',
    templateUrl: './registrieren.component.html',
    styles: [`
        .popup-login {
            padding: 50px 0 0 0px;
            width: 100%;
            height: 100%;
        }

        .form_row {
            padding: 50px 0 0 0px;
        }
    `],
    standalone: false
})

export class RegistrierenComponent implements OnInit {
    public handynummer: string = null;
    public status: string = 'handynummerangeben';
    public name: string = null;
    public code: string = '';
    public handynummer_error: boolean = false;
    public code_error: boolean = false;
    public warten: boolean = false;
    DialogRef: MatDialogRef<DialogComponent>;


    constructor(private dialog: MatDialog,
                private http: HttpClient) {
    }

    ngOnInit() {
        if (localStorage.getItem('MachineId') && localStorage.getItem('AuthentificationKey')) { // Wenn MaschinenID und AuthentificationKey vorhanden sind, dann rücksprung!
            location.href = '/';  //Rücksprung, da man die URL auch direkt aufrufen kann
        }
    }


    identifizieren() {
        this.handynummer_error = false;
        this.code_error = false;

        if (this.handynummer == null) {
            return;
        }
        this.handynummer = this.handynummer.toString().replace(/ /g, '');
        if (this.handynummer.search(/^[0-9]+$/) == -1) {
            alert('Falsches Handynummernformat z.B. 01721234567');
            return;
        }

        if (this.handynummer.substring(0, 2) !== '01') {
            alert('Falsches Handynummernformat z.B. 01721234567');
            return;
        }


        this.warten = true;


        if (this.handynummer_error == false) {
            if (this.status == 'handynummerangeben') {
                this.status = 'waitforcode';
            }
            const params = new HttpParams()
                .set('handynummer', this.handynummer)
                .set('MachineId', '' + localStorage.getItem('MachineId'))
                .set('code', this.code);

            this.http.get('https://fappback.devhm.de/authenticate.php', {params}).subscribe((data: any) => {
                if (data['response'] == 'User unknown') {
                    this.status = 'unbekannt';
                    this.handynummer_error = true;
                    this.warten = false;
                    setTimeout(() => {
                        this.handynummer_error = false;
                        this.status = 'handynummerangeben';
                    }, 2500);
                }
                if (data['response'] == 'User found') {
                    this.DialogRef = this.dialog.open(DialogComponent, {
                        data: {titel: 'Hinweis', text: 'In wenigen Sekunden bekommst Du einen Code per SMS zugeschickt.'}
                    });
                    this.status = 'smsversendet';
                    this.warten = false;
                }

                if (data['response'] == 'Code error') {
                    this.code_error = true;
                    this.warten = false;
                    this.status = 'handynummerangeben';
                    this.DialogRef = this.dialog.open(DialogComponent, {
                        data: {titel: 'Hinweis', text: 'Der angegebene Code ist falsch.'}
                    });
                    this.code = '';
                }
                if (data['response'] == 'User authenticated') {
                    this.warten = false;
                    localStorage.setItem('AuthentificationKey', data['AuthentificationKey']);
                    location.href = '/';
                }
            });
        }
    }
}
